export const LOGO_CROPPED = '/logo-cropped.png';
export const LOGO_WHITE = '/logo-white.png';
